export enum DiscountTypeEnum {
	PERCENTAGE = 'Prozent',
	TOTAL = 'Total',
}
